// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider--u31fhC5iSJ"};